import React, { Component } from 'react'
import { withStyles, Grid , SvgIcon, List, ListItem} from '@material-ui/core';
import { Link } from 'react-router-dom';
import {Star} from '@material-ui/icons'
import {OptionsIcon, DeleteIcon, ShareIcon} from '../../../common/icons' 

const styles = theme => ({
    ulAction: { padding: '0px' },
    liAction: { padding: '0px' },
    buttonAction: { padding: '0px' },
    svgAction: {width : '8em', height:'8em' , marginTop:'30px'},
    starColorActive:{color : '#fcd303'},
    starColorInactive:{color : 'var(--gray)'},
    dropDown: {
        backgroundColor: "#f6f5f9",
        backgroundPosition: "center right 10px",
        backgroundRepeat: "no-repeat",
        color: "#131415",
        borderRadius: "40px",
        fontSize: ".875rem"
    },
    filterContainer: {width: '100% !important'},
    dialogContent: {width: '400px'}
});

export class cdWidget extends Component {  
        showOptions=(field,classes, showForm, showDelete,showShare,favorite,share)=>{
            if(share=== false){
                return(
                    <List className = { classes.ulAction }>
                                            <ListItem className = { classes.liAction }>
                                                <Link className = { classes.buttonAction } to="#" onClick={()=>{showForm(field)}}>
                                                    <OptionsIcon />
                                                </Link>
                                            </ListItem>
                                            <ListItem className = { classes.liAction }>
                                                <Link className = { classes.buttonAction }  to="#" onClick={()=>{showDelete(field.dashboardID)}}>
                                                    <DeleteIcon />
                                                </Link>
                                            </ListItem>
                                            <ListItem className = { classes.liAction }>
                                                <Link className = { classes.buttonAction }  to="#" onClick={()=>{showShare(field)}}>
                                                    <ShareIcon />
                                                </Link>
                                            </ListItem>
                                            <ListItem className = { classes.liAction }>
                                                <Link className = { classes.buttonAction} to="#" onClick={()=>{favorite(field)}}>
                                                    <Star className= {field.isPinned? classes.starColorActive : classes.starColorInactive}></Star>
                                                </Link>
                                            </ListItem>
                                        </List> 
                );
            }else{return <div></div>}
        }

    render() {
        const {classes, data, showForm, showDelete,showShare,favorite,share, addHistory} = this.props;
        const svgIconColor = 'var(--gray)';
        const svgIconPath = 'M12 0C18.6 0 24 5.4 24 12 24 18.6 18.6 24 12 24 5.4 24 0 18.6 0 12 0 5.4 5.4 0 12 0ZM18.6 7L16.8 7 16.7 7C15.9 7.1 15.5 7.5 15.4 8.2L15.4 8.3 15.4 16.7 15.4 16.8C15.5 17.5 15.9 17.9 16.7 18L16.8 18 18.6 18 18.7 18C19.5 17.9 19.9 17.5 20 16.8L20 16.7 20 8.3 20 8.2C19.9 7.5 19.5 7.1 18.7 7L18.6 7ZM12.9 8.7L11.1 8.7 11 8.7C10.2 8.8 9.8 9.2 9.7 9.9L9.7 10 9.7 16.7 9.7 16.8C9.8 17.5 10.2 17.9 11 18L11.1 18 12.9 18 13 18C13.8 17.9 14.2 17.5 14.3 16.8L14.3 16.7 14.3 10 14.3 9.9C14.2 9.2 13.8 8.8 13 8.7L12.9 8.7ZM7.2 10.4L5.4 10.4 5.3 10.4C4.5 10.5 4.1 10.9 4 11.6L4 11.7 4 16.7 4 16.8C4.1 17.5 4.5 17.9 5.3 18L5.4 18 7.2 18 7.3 18C8.1 17.9 8.5 17.5 8.6 16.8L8.6 16.7 8.6 11.7 8.6 11.6C8.5 10.9 8.1 10.5 7.3 10.4L7.2 10.4Z';
        
        return (
            <React.Fragment>
                 {
                     data.data.map((field)=>{
                        return(
                        <Grid item xs={12} sm={6} lg={4} xl={2}>
                            <div className="panel motoristas">
                            <div className='widget-meta'>
                                <div>
                                    <Link onClick={()=>{addHistory(field.dashboardKey)}}>
                                        <h4>{field.name}</h4>
                                    </Link>
                                </div>
                                <div className="widget-actions">
                                    {this.showOptions(field,classes,showForm, showDelete,showShare,favorite,share)}
                                </div>
                            </div>
                                <div className="widget-content">
                                <SvgIcon className= {classes.svgAction} >
                                    <path
                                        fill={ svgIconColor }
                                        d={ svgIconPath }/>
                                </SvgIcon>
                                </div>
                            </div>
                        </Grid>
                        )
                     })
                 }
            </React.Fragment>
        )
    }
}

export default withStyles(styles)(cdWidget);
